import { AbstractPmsApiService } from '../abstract.service';
import { DropCashVoucher } from '../../models';
import { Property } from "../../models";
import { mapGetToPostParams } from "../../../app/helpers";

/**
 * @class DropCashVoucherPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService}
 */
export class DropCashVoucherPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        return '/property/:propertyId/vouchers/drop-cash(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {DropCashVoucher}
     * @protected
     */
    newModel(attributes, ...params) {

        return new DropCashVoucher(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<DropCashVoucher>>}
     */
    get (params = {}, property = null) {

        const url = this.url({
            propertyId: property ? property.id : 0
        });

        return this.http
            .post(url, mapGetToPostParams(params), {
                headers: this.authHeaders,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param model
     * @returns {Promise.<DropCashVoucher>}
     */
    update(model) {

        const url = this.url({
            propertyId: model.property_id,
            id: model.id
        });

        return this.http
            .put(url, model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {DropCashVoucher=} voucher
     * @param {Property=} property
     * @returns {Promise.<boolean>}
     */
    delete(voucher, property) {

        const url = this.url({
            propertyId: property.id,
            id: voucher.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    viewPdf(voucherId, propertyId, params = {}) {
        const url = this.url({propertyId, id: voucherId}) + '/view-pdf';

        return this.http.get(url, {
            headers: this.authHeaders,
            responseType: 'blob',
            params,
        });
    }

    exportExcel(params = {}, property) {
        const url = this.url({
            propertyId: property.id
        }) + '/export-excel';

        return this.http.get(url, {
            headers: this.authHeaders,
            responseType: 'blob',
            params,
        });
    }

    /**
     * @param {Object.<string, *>} paginationData
     * @param {...*} params
     * @returns {PaginationCollection<M>}
     * @protected
     */
    newPaginationCollection(paginationData, ...params) {
        const pagination = super.newPaginationCollection(paginationData, ...params);
        pagination['totalAmount'] = paginationData.total_amount;

        return pagination;
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/vouchers/drop-cash-voucher.service.js